export const AUTH_CONFIG = {
  domain: "trainingbot.auth0.com",
  clientId: "Wx4vlkjhmyHGGfjqWXUYUKvyfRB0E9G5",
  callbackUrl: process.env.REACT_APP_LOCAL || process.env.REACT_APP_PROD
  //callbackUrl: "http://localhost:3000/callback"
};
